// Accept / Decline: a fixed-width pair beside the text under md, a full-width row under it from md up.
export const ConsentActions = ({ onDecide }) => (
  <div className="flex gap-2 shrink-0 md:mt-3 md:gap-2.5">
    <button
      onClick={() => onDecide("accepted")}
      className="btn-accent rounded-full md:flex-1 min-h-11 px-3 md:px-4 text-[12px] uppercase tracking-wider font-bold"
      data-testid="cookie-accept"
    >
      Accept
    </button>
    <button
      onClick={() => onDecide("declined")}
      className="border border-white/20 text-white/90 rounded-full md:flex-1 min-h-11 px-3 md:px-4 text-[12px] uppercase tracking-wider font-bold hover:bg-white/10 transition-colors"
      data-testid="cookie-decline"
    >
      Decline
    </button>
  </div>
);
